import { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomImage, Text } from '@src/components';
import { Form } from 'antd';

import { useMediaQuery } from '@src/hooks/useMediaQuery';

import { getCardWithVouList } from '@src/store/slice/mobilExpressSlice';

import PaymentType from './PaymentType';
import BankContract from './BankContract';
import OrderSummary from './OrderSummary';
import NewCreditCards from './NewCreditCards';
import SavedCreditCards from './SavedCreditCards';
import EftWireTransferCards from './EftWireTransferCards';

import masterCardLogo from '@src/assets/images/cardOrders/mastercard-logo.svg';
import logoMobilExpress from '@src/assets/images/cardOrders/logo-mobilexpress.webp';
import logoAmex from '@src/assets/images/cardOrders/american-express-logo.png';
import logoVisa from '@src/assets/images/cardOrders/visa-inc-logo.svg';

import '@src/styles/autoUploadInstruction/paymentType.scss';

const initialState = {
  savedCreditCards: false,
  newCreditCards: false,
};

function formVisibleReducer(state, action) {
  switch (action.type) {
    case 'savedCreditCards':
      return {
        savedCreditCards: true,
        newCreditCards: false,
      };
    case 'newCardAddFrom':
      return {
        savedCreditCards: false,
        newCreditCards: true,
      };
    default:
      return initialState;
  }
}

const Payment = () => {
  const isMobil = useMediaQuery({ query: '(max-width: 1199.98px)' });

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { currentBank } = useSelector((state) => state?.bank);
  const { paymentType } = useSelector((state) => state?.mobilExpress);
  const { totalAutoLoading } = useSelector((state) => state?.autoUploadInstructions);

  const [counter, setCounter] = useState(0);

  const [formVisible, visibleDispatch] = useReducer(formVisibleReducer, initialState, (state) => {
    return {
      savedCreditCards: false,
      newCreditCards: false,
    };
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      if (paymentType === 1) {
        const action = await dispatch(getCardWithVouList());
        if (getCardWithVouList.fulfilled.match(action)) {
          const array = action.payload.data.cardList;
          if (array.length === 0) {
            visibleDispatch({ type: 'newCardAddFrom' });
          } else {
            visibleDispatch({ type: 'savedCreditCards' });
          }
        } else {
          visibleDispatch({ type: 'newCardAddFrom' });
        }
      } else if (paymentType === 2) {
        visibleDispatch({ type: 'savedCreditCards' });
      }
    })();
  }, [dispatch, paymentType]);

  return (
    <div className="payment-order-content">
      <div className="payment-content">
        <div className="payment-type-content">
          <PaymentType />

          {paymentType === 1 ? (
            <>
              {formVisible?.savedCreditCards && paymentType && (
                <SavedCreditCards
                  counter={counter}
                  setCounter={setCounter}
                  handleAnotherCreditCard={() => visibleDispatch({ type: 'newCardAddFrom' })}
                />
              )}
              {formVisible?.newCreditCards && (
                <NewCreditCards
                  form={form}
                  formVisible={formVisible}
                  counter={counter}
                  setCounter={setCounter}
                  handleRegisteredCreditCard={() => visibleDispatch({ type: 'savedCreditCards' })}
                />
              )}
            </>
          ) : (
            <>
              {currentBank && currentBank !== 'paymentLater' ? (
                <BankContract />
              ) : (
                <EftWireTransferCards type={'balance'} />
              )}
            </>
          )}

          {totalAutoLoading?.paymentType !== 5 && !isMobil && (
            <>
              <hr />
              <div className="footer-logo">
                <div className="left-logos">
                  <CustomImage className="logoMobil" src={logoMobilExpress} />
                  <span className={'left-logos-text'}>
                    <Text t="yourCardsAreStoredSecurelyInThePci" />
                  </span>
                </div>
                <div className="right-logos">
                  <CustomImage src={logoAmex} style={{ width: '50px', height: '50px' }} />
                  <CustomImage src={logoVisa} />
                  <CustomImage src={masterCardLogo} />
                </div>
              </div>
            </>
          )}
        </div>

        <OrderSummary
          counter={counter}
          setCounter={setCounter}
          form={form}
          formVisible={formVisible?.newCreditCards}
        />
      </div>
    </div>
  );
};

export default Payment;
